import { createBrowserRouter, Navigate } from "react-router-dom";
import Main from "../pages/main";
import Home from "../pages/home";
import History from "../pages/history";
import User from "../pages/user";
import Setting from "../pages/setting";
import Login from "../pages/login";
import Static from "../pages/static";
import Pay from "../pages/pay";
import Register from "../pages/register";
import Policy from "../pages/policy/policy";
import About from "../pages/about";

const routes = [
  {
    path: "/",
    Component: Static,
  },
  {
    path: "/Main",
    Component: Main,
    children: [
      {
        index: true,
        element: <Navigate to="home" replace />,
      },
      {
        path: "home",
        Component: Home,
      },
      {
        path: "history",
        Component: History,
      },
      {
        path: "user",
        Component: User,
      },
      {
        path: "setting",
        Component: Setting,
      },
      {
        path: "pay",
        Component: Pay,
      },
    ],
  },
  {
    path: "/login",
    Component: Login,
  },
  {
    path: "/register",
    Component: Register,
  },
  {
    path: "/policy",
    Component: Policy,
  },
  {
    path: "/about",
    Component: About,
  },
];

export default createBrowserRouter(routes);
